import { IIntegrationElement } from "./IIntegrationElement";
import { IntegrationType } from "./IntegrationType";
import { Product } from "./Product";
import { ProductStatus } from "./ProductStatus";

export class IntegrationProduct extends IIntegrationElement {
  product: Product | undefined;
}
